export default {"src":"/_next/static/media/banzai_icon_rgb_white.265b3cb1.svg","height":203,"width":203,"blurWidth":0,"blurHeight":0};